function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "#E5E5E5"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "unverified, unsubscribed",
  filter: "url(#filter0_d_11889_2917)"
}, /*#__PURE__*/React.createElement("rect", {
  x: -261,
  y: -121,
  width: 371,
  height: 237,
  rx: 4,
  fill: "white",
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("g", {
  id: "Frame 35284"
}, /*#__PURE__*/React.createElement("g", {
  id: "Frame 35282"
}, /*#__PURE__*/React.createElement("g", {
  id: "mingcute:notification-off-line",
  clipPath: "url(#clip0_11889_2917)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M10 12.6667C10.0001 13.0031 9.8731 13.3271 9.64437 13.5737C9.41564 13.8204 9.10214 13.9715 8.7667 13.9967L8.6667 14H7.33337C6.9971 14 6.67327 13.8729 6.42676 13.6442C6.18025 13.4154 6.02925 13.102 6.00403 12.7667L6.00004 12.6667H10ZM8.00004 1.33338C9.21002 1.33336 10.3727 1.8033 11.2429 2.64409C12.113 3.48488 12.6226 4.63077 12.664 5.84004L12.6667 6.00004V8.50938L13.8814 10.9387C13.9344 11.0447 13.9609 11.162 13.9587 11.2805C13.9565 11.399 13.9256 11.5152 13.8686 11.6191C13.8117 11.723 13.7304 11.8116 13.6317 11.8773C13.533 11.9429 13.4199 11.9837 13.302 11.996L13.2254 12H12.9427L13.6567 12.714C13.7763 12.834 13.8457 12.995 13.8509 13.1643C13.856 13.3336 13.7966 13.4985 13.6845 13.6256C13.5725 13.7526 13.4163 13.8322 13.2477 13.8483C13.0791 13.8644 12.9107 13.8157 12.7767 13.712L12.714 13.6567L2.34337 3.28671C2.2238 3.16674 2.15439 3.00575 2.14922 2.83645C2.14405 2.66715 2.20351 2.50223 2.31553 2.37519C2.42756 2.24815 2.58374 2.16851 2.75235 2.15244C2.92097 2.13638 3.08937 2.1851 3.22337 2.28871L3.28603 2.34404L4.21404 3.27204C4.64603 2.67154 5.21477 2.18251 5.87324 1.8454C6.5317 1.50828 7.26096 1.33277 8.0007 1.33338H8.00004ZM3.3487 5.61804L4.6667 6.93604V8.50938C4.66669 8.71627 4.61853 8.92031 4.52604 9.10538L3.74603 10.6667H8.39737L9.7307 12H2.7747C2.64969 12.0001 2.52674 11.9681 2.41755 11.9073C2.30835 11.8464 2.21653 11.7586 2.1508 11.6523C2.08507 11.5459 2.04762 11.4246 2.042 11.2997C2.03638 11.1748 2.06279 11.0505 2.1187 10.9387L3.33337 8.50938V6.00004C3.33337 5.87138 3.3387 5.74404 3.3487 5.61804ZM8.00004 2.66671C7.43495 2.66642 6.87907 2.80988 6.3847 3.0836C5.89033 3.35732 5.47371 3.7523 5.17404 4.23138L11.6094 10.6667H12.2547L11.4747 9.10538C11.382 8.92036 11.3336 8.71632 11.3334 8.50938V6.00004C11.3334 5.11599 10.9822 4.26814 10.3571 3.64302C9.73194 3.0179 8.88409 2.66671 8.00004 2.66671Z",
  fill: "#767A8A"
}))))));
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_11889_2917",
  x: -271,
  y: -129,
  width: 391,
  height: 257,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_11889_2917"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow_11889_2917",
  result: "shape"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_11889_2917"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})));
const SvgMuteBell = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMuteBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mute-bell.fc4dd217.svg";
export { ForwardRef as ReactComponent };